import { MEDIA_URL } from '@/constants/env';
import { fadeInUp } from '@/constants/motions';
import ButtonLink from '@/ui/ButtonLink';
import Image from '@/ui/Image';
import { Icon } from '@iconify/react';
import { motion } from 'framer-motion';
import Markdown from 'react-markdown';

export default function OurCompanyBlock({ data }) {
  const safe = data || {};
  const photoUrl = safe?.photo?.data?.attributes?.url || '';
  return (
    <motion.section
      className="my-16 px-4 xl:mt-20"
      initial="hidden"
      transition={{
        ...fadeInUp.transition,
        when: 'beforeChildren',
        staggerChildren: 0.4,
      }}
      variants={fadeInUp}
      viewport={fadeInUp.viewport}
      whileInView="visible"
    >
      <div className="container-screen">
        <div className="grid gap-8 lg:grid-cols-2">
          <motion.div variants={fadeInUp}>
            {photoUrl ? (
              <Image
                alt="Our company"
                className="h-72 overflow-hidden rounded-xl object-cover shadow-lg md:h-80 md:w-2/3 lg:h-full lg:w-full"
                src={MEDIA_URL.concat(photoUrl)}
              />
            ) : null}
          </motion.div>
          <div>
            <motion.h2 className="text-4xl font-medium" variants={fadeInUp}>
              {safe.title}
            </motion.h2>
            <motion.div className="prose prose-neutral mt-6 leading-snug" variants={fadeInUp}>
              {/* <p>
                CEAD N.V. is your EPC partner in Industrial Solutions. This group of companies has
                over 30 years of experience in providing solutions for the Energy, Mining, Water,
                Oil &amp; Gas and (petro) Chemical industries with their Engineering,
                Manpower,Construction &amp; Facility Management subsidiaries.
              </p>
              <p>The professional team of the CEAD group are experts in:</p>
              <ul>
                <li>Multidisciplinary Engineering &amp; Design Services</li>
                <li>
                  Oil &amp; Gas recruitment for companies working in the industry with technical
                  areas such as general construction and revision, tank construction and revision,
                  and pipeline construction.
                </li>
                <li>
                  Development, construction, and management of mechanical, civil and electrical
                  projects.
                </li>
                <li>
                  Sales of various industrial products such as industrial chemicals, piping,
                  fittings and process management products.
                </li>
              </ul>
              <p>
                Operational excellent, guarantied quality, overall occupational health &amp; safety
                and on time delivery of projects, are core values of CEAD, which are guaranteed by
                the international standards of our ISO9001-2015 and ISO45001-2018 certification.
              </p>
              <p>
                CEAD and its world class experienced partners, are anticipating a bright future for
                the development of Suriname and are ready to serve you!
              </p> */}
              <Markdown>{safe.text || ''}</Markdown>
            </motion.div>
            <motion.div className="mt-4" variants={fadeInUp}>
              <ButtonLink
                color="primary"
                href={safe?.link?.url || '#'}
                icon={<Icon height="20" icon="akar-icons:circle-chevron-right" />}
              >
                Read More
              </ButtonLink>
            </motion.div>
          </div>
        </div>
      </div>
    </motion.section>
  );
}
